import { render } from "./DigPinkCampaignPage.vue?vue&type=template&id=b05e7648"
import script from "./DigPinkCampaignPage.vue?vue&type=script&lang=js"
export * from "./DigPinkCampaignPage.vue?vue&type=script&lang=js"

import "./DigPinkCampaignPage.vue?vue&type=style&index=0&id=b05e7648&lang=css"

import exportComponent from "/Users/brianschroeter/Documents/Codex/2026-10-09/task/giving-dashboard-donor-fix/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__